import {Action} from "redux";

import {GetCustomerRequest} from "../request/customer_request";
import {GetCustomerResponse} from "../response/customer_response";

export enum ClientCustomerActionType {
    REQUEST_GET_CUSTOMER = "CLIENT_CUSTOMER_REQUEST_GET_CUSTOMER",
    CALLBACK_GET_CUSTOMER = "CLIENT_CUSTOMER_CALLBACK_GET_CUSTOMER",
}

export interface IRequestGetCustomerAction extends Action {
    type: ClientCustomerActionType.REQUEST_GET_CUSTOMER;
    item: GetCustomerRequest;
}

export interface ICallbackGetCustomerAction extends Action {
    type: ClientCustomerActionType.CALLBACK_GET_CUSTOMER;
    isSuccess: boolean;
    item?: GetCustomerResponse;
    error?: any;
}

export type ClientCustomerAction =
    IRequestGetCustomerAction |
    ICallbackGetCustomerAction ;

export interface IClientCustomerActionCreator {
    requestGetCustomerAction(item: GetCustomerRequest): IRequestGetCustomerAction;

    callbackGetCustomerAction(
        isSuccess: boolean,
        item?: GetCustomerResponse,
        error?: any): ICallbackGetCustomerAction;
}

class ActionCreator implements IClientCustomerActionCreator {
    public requestGetCustomerAction = (item: GetCustomerRequest): IRequestGetCustomerAction => {
        return {
            type: ClientCustomerActionType.REQUEST_GET_CUSTOMER,
            item,
        };
    };

    public callbackGetCustomerAction = (
        isSuccess: boolean,
        item?: GetCustomerResponse,
        error?: any): ICallbackGetCustomerAction => {
        return {
            type: ClientCustomerActionType.CALLBACK_GET_CUSTOMER,
            isSuccess,
            item,
            error,
        };
    };
}

export const createClientCustomerActionCreator = (): IClientCustomerActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/client_customer_action.ts